import React from "react";
import { isBrowserContext } from "../../../../util/ContextHelper";
import ReactDOM from "react-dom";
import styled from "styled-components";

export let alertRoot: Element | null;
if (isBrowserContext())
{
    alertRoot = document.body;
}

export const AlertItem = styled.div`
    position: fixed;
`;

const Alert: React.FC = (props) =>
{
    if (isBrowserContext() && alertRoot)
    {
        return ReactDOM.createPortal(
            <AlertItem {...props}>
                {props.children}
            </AlertItem>,
            alertRoot);
    }

    return null;
};

export default Alert;